<template>
<div id="wrapper">
    <div class="container">
        <div class="form-modal">
            <div class="login-form">
                <h1>Amejpay User Validation</h1>
                <p>Please wait we are validate your email.</p>

                <div class='loader'>
                <div class='loader--dot'></div>
                <div class='loader--dot'></div>
                <div class='loader--dot'></div>
                <div class='loader--dot'></div>
                <div class='loader--dot'></div>
                <div class='loader--dot'></div>
                <div class='loader--text'></div>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
const axios = require("axios");
export default{
    name: 'VerifyUserEmail',
    data() {
        return{
            token_key: this.$route.query.token,
            email: this.$route.query.email,
            errors: [],
        }
    },
    mounted() {
        
        if(this.$route.query.token && this.$route.query.email){
            var formData = new FormData()
            formData.append('token', this.token_key)
            formData.append('email', this.email)

            // for (var pair of formData.entries()) {
            //   console.log(pair[0]+ ', ' + pair[1]);
            // }

            axios.post("emailverify", formData)
            .then((response) => {
                if(response.status == 200){
                    this.$router.replace({
                        name: "login",
                        query: {emailnew: 'success'}
                    })
                }else{
                    this.$router.replace({
                        name: "login",
                        query: {emailnew: 'fail'}
                    })
                }
            })
            .catch((error) => {
                this.$router.replace({
                    name: "login",
                    query: {emailnew: 'fail'}
                })
            })
        }else{
            this.$router.replace({
                name: "login",
                query: {emailnew: 'fail'}
            })
        }
    },
}
</script>

<style scoped>
.container {
  height: 100vh;
  width: 100vw;
  font-family: Helvetica;
}
.form-modal .login-form h1{
    margin-top: 42px;
    line-height: 32px;
    text-align: center;
}
.login-form p{
    text-align: center;
}
.loader:before{
    background-color: rgb(255 255 255 / 70%);
}
.loader {
  height: 20px;
  width: 250px;
  position: absolute;
  top: -250px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.loader--dot {
  animation-name: loader;
  animation-timing-function: ease-in-out;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  background-color: black;
  position: absolute;
  border: 2px solid white;
}
.loader--dot:first-child {
  background-color: #8cc759;
  animation-delay: 0.5s;
}
.loader--dot:nth-child(2) {
  background-color: #8c6daf;
  animation-delay: 0.4s;
}
.loader--dot:nth-child(3) {
  background-color: #ef5d74;
  animation-delay: 0.3s;
}
.loader--dot:nth-child(4) {
  background-color: #f9a74b;
  animation-delay: 0.2s;
}
.loader--dot:nth-child(5) {
  background-color: #60beeb;
  animation-delay: 0.1s;
}
.loader--dot:nth-child(6) {
  background-color: #fbef5a;
  animation-delay: 0s;
}
.loader--text {
  position: absolute;
  top: 200%;
  left: 0;
  right: 0;
  width: 4rem;
  margin: auto;
}
.loader--text:after {
  content: "Loading";
  font-weight: bold;
  animation-name: loading-text;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

@keyframes loader {
  15% {
    transform: translateX(0);
  }
  45% {
    transform: translateX(230px);
  }
  65% {
    transform: translateX(230px);
  }
  95% {
    transform: translateX(0);
  }
}
@keyframes loading-text {
  0% {
    content: "Loading";
  }
  25% {
    content: "Loading.";
  }
  50% {
    content: "Loading..";
  }
  75% {
    content: "Loading...";
  }
}
</style>